// extracted by mini-css-extract-plugin
module.exports = {"root":"Loader_root__2HMzl","pulsePolygon":"Loader_pulsePolygon__25DQA","inner":"Loader_inner__1cwcL","text":"Loader_text__3Aox8"};